import { Button, Form, Checkbox, message, Modal, Tabs, Upload } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CollectionServer, deleteInArray, DropdownAction, errorCatch, GET, GETWITH, JSX, JSXMap, Model, POST, POSTFormData, QueryDetail, QueryOrder, QueryParam, QueryParams, updateInArray, useCollectionRef } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import { DatabaseOutlined, ExclamationCircleOutlined, FileExcelOutlined, UploadOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/ru_RU';
import { DatePicker, Space } from 'antd';
import User from '../../../common/User';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';
import InputWithSearchModal from '../../components/InputWithSearchModal';
const { RangePicker } = DatePicker;

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


function getCurrencyValue(value, color) {
    if (!value) {
        return (<span style={{ color: "grey" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}

function CRow({ auth, item, idx, account: meropriyatie, setCollectionItem, modelActions, collection, setCollection }) {
    // const [collapsed, setCollapsed] = useState(true);

    const rowColor = (false) ? "bg-red" : "bg-grey";
    return (<React.Fragment key={idx}>
        <tr key={idx} className={'pointer'}
        // onClick={() => {
        //     POST(auth, "/api/rezultati-meropriyatiya/update-ne-uchastvuet-v-reitinge", { ...item, neUchastvuetVReitinge: !item.neUchastvuetVReitinge }, ({ data }) => {
        //         setCollectionItem(data)
        //     }, errorCatch)
        //     // setCollapsed(o => !o);
        // }}
        >
            {/* <td className={`fill`}><div className={`bg ${rowColor}`} style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td> */}

            {/* <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`} style={{ minWidth: "24px", maxWidth: "25px" }}>
                    {(item?.neUchastvuetVReitinge) ? <i className="fa fa-times"></i> : ""}
                </div>
            </td> */}
            <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    ({item?.kategoriyaUchastnikovSerii?.tantsevalnayaDistsiplinaID}) {item?.kategoriyaUchastnikovSerii?.tantsevalnayaDistsiplina?.nazvanie}
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    ({item?.kategoriyaUchastnikovSerii?.kategoriyaUchastnikovID}) {item?.kategoriyaUchastnikovSerii?.kategoriyaUchastnikov?.nazvanie}
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    {item?.place}
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.uchastnik?.genderID === 1) ? "blue" : "red"}`}>
                    {item?.uchastnik?.lastname} {item?.uchastnik?.firstname}
                </div>
            </td>
            {/* <td className={`fill`}>{item?.uchastnik?.city?.name}</td> */}
            <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    {item?.resultPoints}
                </div>
            </td>
            <td className={`fill`} onClick={(e) => { e.stopPropagation() }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`bg ${rowColor} pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </td>
        </tr>
        {/* {(!collapsed) && <tr>
            <td colSpan={5} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>

                    <div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
                        <span style={{ fontWeight: "400", fontSize: "12px" }}>
                            {(item?.dvizhenieDeneg?.ukhodID == meropriyatie.ID) && <Icofont icon="user-alt-3" />}
                            {(item?.dvizhenieDeneg?.ukhodID != meropriyatie.ID) && ((item?.dvizhenieDeneg?.ukhodID) ? <span>
                                {item?.dvizhenieDeneg?.ukhodVladelets}
                            </span> : "Зачисление денежных средств")} {(item?.dvizhenieDeneg?.osnovanie?.ownerType == 'ekvairing') ? '(эквайринг)' : ''}
                        </span>
                        <Icofont icon="long-arrow-right" />
                        <span style={{ fontWeight: "400", fontSize: "12px" }}>
                            {(item?.dvizhenieDeneg?.prikhodID == meropriyatie.ID) && <Icofont icon="user-alt-3" />}
                            {(item?.dvizhenieDeneg?.prikhodID != meropriyatie.ID) && ((item?.dvizhenieDeneg?.ukhodID) ? <span>
                                {item?.dvizhenieDeneg?.prikhodVladelets}
                            </span> : "Вывод денежных средств")}
                        </span>
                    </div>
                    <div style={{ fontWeight: "300" }}>
                        {item?.dvizhenieDeneg?.opisanie}
                    </div>
                    <div style={{ fontWeight: "300" }}>
                        {item?.dvizhenieDeneg?.comment}
                    </div>
                </div>
            </td>
        </tr>} */}
    </React.Fragment>)
}

export default function RezultatiPoMeropriyatiuVSerii(props) {
    const { auth, object } = props;

    const filters = () => [
        {
            label: "Место",
            name: "place",
            sort: true,
            filter: true,
        },
        {
            label: "Очки",
            name: "resultPoints",
            sort: true,
            filter: true,
        },
        {
            name: "uchastnik.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "uchastnik.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "uchastnik.gender",
            display: (o) => o.name,
            queryFilter: [
                QueryOrder("name", "ASC"),
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Дисциплина",
            name: "KategoriyaUchastnikovSerii.tantsevalnayaDistsiplina",
            filterType: "group",
            display: (o) => o.nazvanie,
            queryFilter: [
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Категория",
            name: "KategoriyaUchastnikovSerii.kategoriyaUchastnikov",
            filterType: "group",
            display: (o) => o.nazvanie,
            queryFilter: [
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: true,
            filter: true,
        },
    ];

    const cref = useCollectionRef()
    const [loading, setLoading] = useState(false)
    return (
        <>
            {props.subheader}


            <CollectionServer
                auth={auth}
                name={"RezultatiSerii"}
                source={`/api/meropriyatie-v-serii/get-rezultati/${object.ID}`}
                // contextFilters={() => [
                //     QueryOrder("isAdmin", "DESC")
                // ]}
                collectionRef={cref}
                filters={filters}
                customRender={(items, {
                    collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    collectionActions,
                    modelActions,
                    update
                }) => (
                    <div className='scrollable'>
                        <table className="table" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr>
                                    {/* <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}>
                                        <div className='bg bg-grey dark-1' style={{ minWidth: "24px", maxWidth: "25px" }}>
                                            <i className="fa fa-times"></i>
                                        </div>
                                    </th> */}
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Дисциплина</div></th>
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Категория</div></th>
                                    <th className={`wrap`} style={{ minWidth: "45px", maxWidth: "45px" }}><div className='bg bg-grey dark-1'>Место</div></th>
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Участник</div></th>
                                    {/* <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Город</div></th> */}
                                    <th className={`wrap`} style={{ minWidth: "45px", maxWidth: "45px" }}><div className='bg bg-grey dark-1'>Очки</div></th>
                                    <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                {JSXMap(items, (o, oidx) => {
                                    return (<CRow key={oidx} auth={auth} item={o} idx={oidx} meropriyatie={object?.meropriyatie} collection={collection} setCollection={setCollection} setCollectionItem={setCollectionItem} modelActions={modelActions} />)
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                size={"small"}

                collectionActions={() => [{
                    auth: auth,
                    action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/rezultati-serii/create`, { ...values, meropriyatieVSeriiID: object.ID }, ({ data }) => {
                        setCollection(updateInArray(collection, data));
                        close();
                    }, (err) => errorCatch(err, unlock)),
                    title: "Добавить строку результатов",
                    form: Model,
                    meta: [
                        {
                            label: "Участник",
                            name: "uchastnik",
                            type: "object",
                            mode: "dialog",
                            modal: { width: "700px" },
                            relation: {
                                uiFilter: () => [
                                    {
                                        name: "lastname",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "firstname",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "patronymic",
                                        sort: true,
                                        filter: true,
                                    },

                                    {
                                        name: "email",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        label: "Телефон",
                                        name: "phone",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "gender",
                                        sort: true,
                                        filter: true,
                                        display: (o) => o.name,
                                    },
                                    {
                                        label: "Дата создания",
                                        name: "createdAt",
                                        type: "date",
                                        sort: true,
                                        filter: true,
                                    },
                                ],
                                displayString: (item) => {
                                    return item?.lastname + " " + item?.firstname
                                },
                                display: (item) => {
                                    return (
                                        <User item={item} />
                                    )
                                },
                                reference: { object: "User", property: "ID", /*source: "/api/meropriyatiya/list/com"*/ },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("combobox"),
                                QueryOrder("firstname", "ASC")
                            ]
                        },
                        // {
                        //     label: "Участник",
                        //     name: "uchastnik",
                        //     type: "func",
                        //     render: (auth, item, value, onChange) => {
                        //         return (
                        //             <InputWithSearchModal value={value} onChange={onChange} valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        //                 searchForm={UserFilter}
                        //                 selectForm={UserSelector} />
                        //         )
                        //     }
                        // },
                        {
                            label: "Категория участников",
                            name: "KategoriyaUchastnikovSerii",
                            type: "object",
                            relation: {
                                display: (item) => {
                                    return item.tantsevalnayaDistsiplina.nazvanie + " - " + item.kategoriyaUchastnikov.nazvanie
                                },
                                reference: { object: "KategoriiUchastnikovSerii", property: "ID" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("model"),
                                QueryOrder("tantsevalnayaDistsiplina.nazvanie", "ASC"),
                                QueryParam("w-seriya", object?.seriya.ID)
                            ]
                        },
                        {
                            label: "Место",
                            name: "place",
                            type: "int",
                        },
                        {
                            label: "Очки",
                            name: "resultPoints",
                            type: "int",
                        },
                    ],
                },
                ({ collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    onSelection,
                    isSelected,
                    lock,
                    unlock,
                    loading: collectionLoading,
                    update }, idx) => {
                    return (<Button key={idx} loading={loading} icon={<DatabaseOutlined />} onClick={(e) => {
                        // setLoading(true);
                        confirmKey({
                            pass: '123',
                            zIndex: 40000,
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Перезагрузка результатов</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите перезагрузить результаты мероприятия в серии? Старые результаты мероприятия для этой серии будут удалены.</span>,
                            okText: 'Да',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, `/api/meropriyatiya/create-rezultati-meropriyatie-seriya/${object?.meropriyatieID}/${object?.seriyaID}`, ({ rezultatiMeropriyatii }) => {
                                        message.success(`Загрузка завершена`);
                                        update();
                                        resolve()
                                        // setLoading(false);

                                    }, (err) => { 
                                        const hide = message.error({content: err?.message||"Ошибка", duration: 5, onClick: (e)=>{
                                                hide();
                                            }});
                                        // setLoading(false)
                                        reject()
                                    })
                                }).catch(() => { });
                            },
                            onCancel() {
                                // setLoading(false)
                            },
                        })
                    }}>Перезагрузить результаты</Button>)
                }
                ]}
                modelActions={(item) => [{
                    auth: auth,
                    title: "Изменить",
                    modal: {
                        width: "600px",
                        title: "Изменить строку результатов",
                    },
                    object: item,
                    action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/rezultati-serii/update`, { ...item, ...values, ID: item.ID, meropriyatieVSeriiID: object.ID },
                        ({ data }) => {
                            setCollection(updateInArray(collection, data));
                            close();
                        },
                        (err) => errorCatch(err, unlock)),
                    form: Model,
                    meta: [
                        {
                            type: "func",
                            render: (auth, _item) => {
                                return (<div>
                                    <div><User item={item?.uchastnik} /></div>
                                    <div>{item?.kategoriyaUchastnikovSerii?.tantsevalnayaDistsiplina?.nazvanie + " - " + item?.kategoriyaUchastnikovSerii?.kategoriyaUchastnikov?.nazvanie}</div>
                                </div>)
                            }
                        },
                        // {
                        //     label: "Участник",
                        //     name: "uchastnik",
                        //     type: "object",
                        //     mode: "dialog",
                        //     modal: { width: "700px" },
                        //     relation: {
                        //         uiFilter: () => [
                        //             {
                        //                 name: "lastname",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 name: "firstname",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 name: "patronymic",
                        //                 sort: true,
                        //                 filter: true,
                        //             },

                        //             {
                        //                 name: "email",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 label: "Телефон",
                        //                 name: "phone",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 name: "gender",
                        //                 sort: true,
                        //                 filter: true,
                        //                 display: (o) => o.name,
                        //             },
                        //             {
                        //                 label: "Дата создания",
                        //                 name: "createdAt",
                        //                 type: "date",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //         ],
                        //         displayString: (item) => {
                        //             return item?.lastname + " " + item?.firstname
                        //         },
                        //         display: (item) => {
                        //             return (
                        //                 <User item={item} />
                        //             )
                        //         },
                        //         reference: { object: "User", property: "ID", /*source: "/api/meropriyatiya/list/com"*/ },
                        //         type: "many-one",
                        //     },
                        //     queryFilter: [
                        //         QueryDetail("combobox"),
                        //         QueryOrder("firstname", "ASC")
                        //     ]
                        // },
                        // {
                        //     label: "Участник",
                        //     name: "uchastnik",
                        //     type: "func",
                        //     render: (auth, item, value, onChange) => {
                        //         return (
                        //             <InputWithSearchModal value={value} onChange={onChange} valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        //                 searchForm={UserFilter}
                        //                 selectForm={UserSelector} />
                        //         )
                        //     }
                        // },
                        // {
                        //     label: "Категория участников",
                        //     name: "KategoriyaUchastnikovSerii",
                        //     type: "object",
                        //     relation: {
                        //         display: (item) => {
                        //             return item.tantsevalnayaDistsiplina.nazvanie + " - " + item.kategoriyaUchastnikov.nazvanie
                        //         },
                        //         reference: { object: "KategoriiUchastnikovSerii", property: "ID" },
                        //         type: "many-one",
                        //     },
                        //     queryFilter: [
                        //         QueryDetail("model"),
                        //         QueryOrder("tantsevalnayaDistsiplina.nazvanie", "ASC"),
                        //         QueryParam("w-meropriyatie", object.ID)
                        //     ]
                        // },
                        {
                            label: "Место",
                            name: "place",
                            type: "int",
                        },
                        {
                            label: "Очки",
                            name: "resultPoints",
                            type: "int",
                        },
                    ],
                },
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить строку результатов</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить строку результатов?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/rezultati-serii/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })
                    }
                }]}
            />
        </>
    );
}
